import React, { useEffect, useRef, useState } from 'react'
import useTranslate from '../useTranslate'
import useStyles from '../styles'

const CopyLinkButton: React.FC = () => {
  const classes = useStyles()
  const t = useTranslate()
  const [copied, setCopied] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(
    () => () => {
      if (timeoutRef.current !== null) clearTimeout(timeoutRef.current)
    },
    [],
  )

  const handleCopy = (): void => {
    void navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        setCopied(true)
        if (timeoutRef.current !== null) clearTimeout(timeoutRef.current)
        timeoutRef.current = setTimeout(() => setCopied(false), 1200)
      })
      .catch(() => {
        // Clipboard can be blocked (permissions / insecure origin); ignore.
      })
  }

  return (
    <button
      type='button'
      className={classes.exportButton}
      onClick={handleCopy}
      title={t('log_viewer.copy_link_title')}
    >
      <span
        className='material-symbols-outlined'
        style={{ fontSize: 16 }}
      >
        {copied ? 'check' : 'link'}
      </span>
      <span>{copied ? t('log_viewer.copied') : t('log_viewer.copy_link')}</span>
    </button>
  )
}

export default CopyLinkButton
